import $ from '@modules/jquery-import';

/* Custom Effects */
$.fn.jiggle = function ( fn ) {
    var _this = this;

    $( this ).css( 'position', 'relative' ).animate( {
        left: '+=10'
    }, 40 ).animate( {
        left: '-=20'
    }, 40 ).animate( {
        left: '+=20'
    }, 40 ).animate( {
        left: '-=10'
    }, 40, function () {
        if ( typeof fn === 'function' ) {
            fn.call( _this );
        }
    } );
};
